import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14cd428d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: "pending",
  class: "button"
}
const _hoisted_3 = {
  key: "addToBasket",
  class: "button"
}
const _hoisted_4 = { class: "button-text__label transition-transform duration-300 ease-in-out" }

import { computed, Ref, ref } from 'vue';
import utilities from '@/shared/utilities.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToBasketHandler',
  props: {
    buttonText: null,
    lightMode: { type: Boolean },
    handler: null
  },
  setup(__props: any) {

const props = __props as {
    buttonText?: string;
    lightMode?: boolean;
    handler:() => Promise<void>;
}



const pending: Ref<boolean> = ref(false);
const timing: number = 2000;

const enterAnimation = computed(() => {
    const animation = pending.value ? 'fadeInDown' : 'fadeInUp';
    return `${animation} animated u-anim-dur-300`;
});

const leaveAnimation = computed(() => {
    const animation = pending.value ? 'fadeOutDown' : 'fadeOutUp';
    return `${animation} animated u-anim-dur-300`;
});

const buttonClassName = computed(() => {
    const modifier = props.lightMode ? 'c-button--basket-light' : 'c-button--basket';
    return `c-button ${modifier}`;
});

const add = async() => {
    if (!pending.value) {
        pending.value = true;
        const animationTiming = utilities.delay(timing);
        try {
            await Promise.all([
                props.handler(),
                animationTiming,
            ]);
        } finally {
            pending.value = false;
        }
    }
};

return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(_unref(buttonClassName)),
    title: __props.buttonText,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (add()), ["prevent"]))
  }, [
    _createVNode(_Transition, {
      mode: "out-in",
      "enter-active-class": _unref(enterAnimation),
      "leave-active-class": _unref(leaveAnimation)
    }, {
      default: _withCtx(() => [
        (pending.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_c_icon, {
                name: "icon-checkmark-medium",
                class: "h-15 mr-5"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$dictionary.get('b2c/basket/added')), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(__props.buttonText), 1),
              _createVNode(_component_c_icon, {
                name: "icon-plus-small",
                title: __props.buttonText,
                class: "button-text__icon transition-opacity duration-300 ease-in-out",
                height: "12"
              }, null, 8, ["title"])
            ]))
      ]),
      _: 1
    }, 8, ["enter-active-class", "leave-active-class"])
  ], 10, _hoisted_1))
}
}

})